import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
import LocalStorage from "@/common/localstorage";

const companies = window.companies || [];
const defaultCompanyID = companies.length ? companies[0].id : null;
let currentCompanyId = LocalStorage.get("current-company", null);
if (!companies.some((c) => c.id === currentCompanyId)) {
  currentCompanyId = defaultCompanyID;
}
LocalStorage.set("current-company", currentCompanyId);

const state = {
  companies: companies,
  currentCompanyId,
  company: null,
  inProgress: false,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
